import { useEffect } from 'react'
import { useRecoilValue, useResetRecoilState } from 'recoil'

import CardWithBorder from '../../../components/CardWithBorder'
import TableWithPagination from '../../../components/TableWIthPagination'
import { API_PARAMS, PAGE_SIZE } from '../../../config/consts'
import useGetCampaignList from '../../../hooks/api/useGetCampaignList'
import { ServiceAtom, TableAtom } from '../../../recoil/atoms'
import { calcOffset, parseNumber } from '../../../utils/display'
import useGetStampCampaignRank from '../hooks/useGetStampCampaignRank'

function StampCampaignRanking({ className }: { className?: string }) {
  const service = useRecoilValue(ServiceAtom)
  const { campaigns } = useGetCampaignList()
  const oldestDate = campaigns?.length
    ? campaigns.reduce((prev, current) => (prev.startDate < current.startDate ? prev : current))
    : undefined
  const latestDate = campaigns?.length
    ? campaigns.reduce((prev, current) => (prev.endDate > current.endDate ? prev : current))
    : undefined
  const tableOpt = useRecoilValue(TableAtom('campaignRankings'))
  const resetTableOpt = useResetRecoilState(TableAtom('campaignRankings'))

  const { stampCampaignRankStoreRank, stampCampaignRankStoreRankLoading } = useGetStampCampaignRank({
    serviceId: service.value,
    campaignId: API_PARAMS.SELECT_ALL,
    fromDate: oldestDate?.startDate.split(' ')[0],
    toDate: latestDate?.endDate.split(' ')[0],
    offset: calcOffset(tableOpt.current, PAGE_SIZE),
    sortTarget: tableOpt.sortTarget ?? 2,
    isAsc: tableOpt.isAsc,
  })

  useEffect(() => {
    resetTableOpt()
  }, [service, resetTableOpt])

  return (
    <CardWithBorder
      className={`${className} relative`}
      title='スタンプキャンペーンランキング'
      visible={stampCampaignRankStoreRankLoading}
    >
      <TableWithPagination
        labels={[
          'キャンペーンID',
          'キャンペーン名',
          'スタンプ数',
          'リワード発行数',
          'リワード利用数',
          'リワード利用率',
        ]}
        name='campaignRankings'
        unSortableIndex={[0, 1]}
        rightAlignedColumns={[2, 3, 4, 5]}
        columnWidths={['20%', '40%', '8%', '8%', '8%', '8%']}
        elements={
          stampCampaignRankStoreRank?.pushNotificationCampaignRankDatas?.map((e) => [
            e.campaignId?.toString() ?? e.campaignId,
            e.campaignName,
            `${parseNumber(e.stampCountTotal)} 回`,
            `${parseNumber(e.rewardCountTotal)} 回`,
            `${parseNumber(e.rewardRedeemCountTotal)} 回`,
            `${e.rewardRedeemRate.toFixed(2)} %`,
          ]) ?? []
        }
        pageSize={PAGE_SIZE}
        total={stampCampaignRankStoreRank?.totalCount ?? 0}
      />
    </CardWithBorder>
  )
}

StampCampaignRanking.defaultProps = {
  className: '',
}

export default StampCampaignRanking
